import React from "react";
import Modal from "../common/Modal";
import { QRCodeSVG } from "qrcode.react";

export default function ShareGameLinkModal({
  show,
  onClose,
  shareUrl,
  copied,
  handleCopy,
  playerFilter,
  setPlayerFilter,
  filteredPlayers,
  selectedInvitees,
  setSelectedInvitees,
  onSendInvite,
  onClear,
}) {
  return (
    <Modal show={show} title="Share Room Link" onClose={onClose}>
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg w-full max-w-2xl p-4">
        <div className="flex items-center gap-2 mb-4">
          <input
            type="text"
            value={shareUrl}
            readOnly
            className="w-full px-2 py-1 border rounded bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-100 text-sm"
            onFocus={(e) => e.target.select()}
          />
          <button
            className="px-2 py-1 rounded bg-blue-500 hover:bg-blue-600 text-white text-xs font-semibold"
            onClick={handleCopy}
          >
            {copied ? "Copied!" : "Copy"}
          </button>
        </div>
        <div className="text-xs text-gray-500 dark:text-gray-400">
          Anyone with this link can join this room directly.
        </div>
        <div className="mt-3 flex justify-center">
          <div className="rounded-lg border border-gray-200 dark:border-gray-700 bg-white p-3">
            <QRCodeSVG value={shareUrl || ""} size={148} includeMargin />
          </div>
        </div>
        <div className="mt-1 text-center text-xs text-gray-500 dark:text-gray-400">
          Scan to open the same room link.
        </div>
        <hr className="my-3" />
        <div>
          <h4 className="text-sm font-semibold mb-1 text-gray-900 dark:text-gray-100">Invite Player from Lobby or Game</h4>
          <input
            className="w-full px-2 py-1 mb-2 border rounded text-sm bg-white text-gray-800 border-gray-300 dark:bg-gray-700 dark:text-gray-100 dark:border-gray-600"
            placeholder="Filter players by name..."
            value={playerFilter}
            onChange={(e) => setPlayerFilter(e.target.value)}
          />
          <div className="max-h-36 overflow-y-auto border rounded p-1 mb-2 bg-white dark:bg-gray-800">
            {filteredPlayers.map((p) => (
              <label key={p.socketId} className="flex items-center gap-2 text-sm p-1 rounded hover:bg-gray-100 dark:hover:bg-gray-700">
                <input
                  type="checkbox"
                  className="accent-blue-500"
                  checked={selectedInvitees.includes(p.socketId)}
                  onChange={(e) => {
                    if (e.target.checked) setSelectedInvitees((s) => [...s, p.socketId]);
                    else setSelectedInvitees((s) => s.filter((id) => id !== p.socketId));
                  }}
                />
                <span className="ml-1 text-gray-900 dark:text-gray-100">{p.username} {p.socketId === (typeof window !== 'undefined' && window?.socket?.id) ? "(You)" : ""}</span>
              </label>
            ))}
            {filteredPlayers.length === 0 && <div className="text-xs text-gray-500 dark:text-gray-300 p-2">No players match</div>}
          </div>
          <div className="flex gap-2">
            <button
              className="px-3 py-1 rounded bg-green-500 hover:bg-green-600 dark:bg-green-600 dark:hover:bg-green-700 text-white text-xs font-semibold"
              disabled={selectedInvitees.length === 0}
              onClick={onSendInvite}
            >
              Send Invite
            </button>
            <button
              className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 text-xs font-semibold text-gray-700 dark:text-gray-200"
              onClick={onClear}
            >
              Clear
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
